import {observable, action, runInAction, computed} from 'mobx'
import {json, get} from '../../../../utils/ajax'
import {findChildren, objToValueObj, setStore} from '../../../../utils/Utils'
import {message} from "antd";

class ManualCatalogStore {

    @observable loading
    @observable list //车系list
    @observable page //分页
    @observable brands //品牌下拉框
    @observable carSeries //车系下拉框
    @observable addSelModal //新增车系模态框
    @observable carSerie
    @observable brandId //品牌id
    @observable carSeriesId //车系id
    @observable modalSelect
    @observable carseriesName //车系名称
    @observable saveData
    @observable tree //车系目录list树
    @observable editCarseriesId //车系ID
    @observable editCarseriesCode //车系code
    @observable editBrandid //ID
    @observable rowData //一级目录
    @observable rightTable //右边列表数据
    @observable importReturnData //存储导入是返回错误的数据
    @observable expandedLeftRowKeys//扩展的左行键
    @observable stLevel1DirectoryIDOnTheLeft//左侧1级目录ID
    @observable stLevel2DirectoryIDOnTheLeft//左侧2级目录ID
    @observable selectedRowKeys //展开左侧树
    @observable addBoxModal //新增目录模态框
    @observable optionModal //记录新增修改目录名称
    @observable showDrawer //导入返回数据
    @observable editFields //新增修改存值

    constructor() {
        this.loading = false
        this.list = []
        this.page = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.brands = {
            list: [],
            selected: '',
        }
        this.carSeries = {
            list: [],
            selected: ''
        }
        this.addSelModal = false
        this.carSerie = {}
        this.brandId = []
        this.carSeriesId = []
        this.modalSelect = false
        this.carseriesName = ''
        this.saveData = ''
        this.tree = []
        this.editCarseriesId = ''
        this.editCarseriesCode = []
        this.editBrandid = ''
        this.rowData = {}
        this.rightTable = []
        this.importReturnData = []
        this.expandedLeftRowKeys = []
        this.stLevel1DirectoryIDOnTheLeft = ''
        this.stLevel2DirectoryIDOnTheLeft = ''
        this.selectedRowKeys = []
        this.addBoxModal = false
        this.optionModal = ''
        this.showDrawer = false
        this.editFields = {}
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /**
     * 初始化页面
     */
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCarseriesCatalog/list`, {
            page: page - 1,
            carseriesName: '',
            size: this.page.pageSize
        })
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content || []
            this.rightTable = []
            this.page = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /**
     * 初始化品牌下拉框
     */
    @action
    initBrands = async () => {
        runInAction(() => {
            this.carSeries = {
                list: [],
                selected: ''
            }
            this.addSelModal = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/get/all`)
        runInAction(() => {
            this.brands.list = Array.isArray(res) ? res : []
            let brand = this.brands.list.find((item) => item.defaultName === '')
            let value = brand && brand.defaultName
            this.initCarseries(value)
        })
    }

    /**
     * 初始化车系下拉框
     */
    @action
    initCarseries = async (value) => {
        let brand = this.brands.list.find((item) => item.defaultName === value)
        let ids = brand && brand.id
        if (!ids) {
            return
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/carsystem/ids`, {ids})
        runInAction(() => {
            this.carSeries.list = Array.isArray(res) ? res : []
            this.brand = brand
        })
    }

    @action
    selectCarseries = (value) => {
        let carSerie = this.carSeries.list.find((item) => item.defaultName === value)
        this.carSerie = carSerie
    }


    /**
     * 选中品牌
     */
    @action
    saveBrandId = (value) => {
        runInAction(() => {
            this.brandId = value
        })
    }

    /**
     * 选中车系
     */
    @action
    saveCarSeriesId = (value) => {
        runInAction(() => {
            this.carSeriesId = value
        })
    }

    /**
     * 取消编辑
     */
    @action.bound
    cancelEdit() {
        this.loading = false
        this.modalSelect = false
        this.addSelModal = false
    }

    /**
     * 保存选中的车系和品牌记录
     */
    @action
    saveCatalog = async () => {
        const data = {
            'carseriesName': this.carSerie.defaultName,
            'carseriesImage': this.carSerie.icon,
            'brandId': this.brand.id,
            'brandName': this.brand.defaultName,
            'carseriesId': this.carSerie.id,
            'carseriesCode': this.carSerie.carSeriesCode,
            'state': 0,
            'rank': this.carSerie.rank
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCarseriesCatalog/add`, data)
        if (res && res.status === 0) {
            message.warning('车系已存在请勿重复新增！')
            this.loading = false
            return
        }
        runInAction(() => {
            this.addSelModal = false
        })
        this.initListPage(0)
    }

    /**
     * 删除车系
     */
    @action
    deleteByCarseriesId = async (record) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCarseriesCatalog/delete?id=` + record.id + '&&carseriesId=' + record.carseriesId)
        if (res && res.status === 0) {
            return
        }
        await this.initListPage(this.page)
    }

    /**
     * 发布
     * @param rocord
     * @returns {Promise.<void>}
     */
    @action
    publishByCarseriesId = async (rocord) => {
        let state = rocord.state ? 0 : 1;
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCarseriesCatalog/${rocord.id}/state/${state}`)
        this.initListPage(this.page)
    }

    /**
     * 撤销
     * @param rocord
     * @returns {Promise<void>}
     */
    @action
    revokeByCarseriesId = async (rocord) => {
        let state = rocord.state ? 0 : 1;
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCarseriesCatalog/${rocord.id}/state/${state}`)
        this.initListPage(this.page)
    }

    /**
     * 初始化目录树表
     */
    @action
    initEditPage = async (record) => {
        this.loading = true
        this.saveData = record
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/queryListByCarCode?carseriesId=${record.carseriesId}`)
        runInAction(() => {
            this.tree = Array.isArray(res) ? findChildren(res) : []
            this.editCarseriesCode = record.carseriesCode
            this.editCarseriesId = record.carseriesId
            this.editBrandid = record.id
            this.rowData = {}
            this.loading = false
        })
    }

    /**
     * 获取右边一级表格数据
     * @param record
     * @returns {Promise<void>}
     */
    @action
    getRightLevel1Data = async (carseriesId) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/queryTheLevel1DirectoryAccordingToTheCarCode?carseriesId=${carseriesId}`)
        runInAction(() => {
            this.rightTable = res
            this.loading = false
        })
    }

    /***
     * 上传开抽屉
     */
    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /***
     * 关闭抽屉
     */
    @action
    onClose = () => {
        this.showDrawer = false
    }

    /**
     * 获取右边表格数据
     * @param record
     * @returns {Promise<void>}
     */
    @action
    getRightData = async (record) => {
        this.rowData = record
        if (record.level < 4) {
            this.loading = true
            const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/querySonData?carseriesId=${record.carseriesId}&&pid=${record.id}`)
            runInAction(() => {
                this.rightTable = res
                this.loading = false
            })
        }
    }

    /**新增修改模态框**/
    @action
    showBox = (record, option) => {
        runInAction(() => {
            if (option === 'update') {
                this.editFields = objToValueObj(record)
            } else {
                this.editFields = {}
            }
            this.loading = true
            this.info = record
            this.option = option
            this.optionModal = option === 'addSame' ? '新增同级' : option === 'update' ? '修改' : '新增下级'
            this.addBoxModal = true
            this.loading = false
        })
    }

    /**删除**/
    @action
    deleteOne = async (record) => {
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/delById/id/${record.id}`)
        runInAction(() => {
            this.initEditPage(this.saveData)
        })
    }

    @computed
    get fields() {
        let fields = {
            code: {value: this.editFields.code},
            name: {value: this.editFields.name},
        }
        return fields
    }

    //Cast
    @action
    onEditFieldChange(changedFields) {
        this.editFields = {...this.editFields, ...changedFields}
    }

    /**
     * 新增同级/下级
     * @param content
     * @param option
     * @returns {Promise.<void>}
     */
    @action
    operation = async (content) => {
        let info = this.info
        this.loading = true
        let data = {
            'id': this.editBrandid,
            'carseriesId': this.editCarseriesId,
            'carseriesCode': this.editCarseriesCode,
            'name': content.name,
            'code': content.code,
        }
        if (this.option === 'addSame') {//添加同级
            data.level = info.level
            data.pid = info.pid
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/addSameLevel`, data)
            if (res && res.status === 0) {
                message.warning('章节验证中不存在此数据！')
                this.loading = false
                return
            }
        } else if (this.option === 'addChild') {//添加下级
            data.level = info.level + 1
            data.pid = info.id
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/addSubordinate`, data)
            if (res && res.status === 0) {
                message.warning('章节验证中不存在此数据！')
                this.loading = false
                return
            }
            this.level = res.level
        } else if (this.option === 'update') {//修改
            data.id = info.id
            data.level = info.level
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/updateLv3Catalog`, data)
            if (res.status) {
                message.success(`修改成功！`)
            } else {
                message.warning(`该目录已存在，请勿重新添加!`)
            }
            this.getRightLevel1Data(this.editCarseriesId)
        }
        runInAction(() => {
            this.loading = false
            this.addBoxModal = false
            this.getRightData(this.rowData)
            this.initEditPage(this.saveData)
        })
    }

}

export default new ManualCatalogStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/manual/manualCatalog/store.js